import * as React from 'react';

import { type HeroBentoCardType, HeroBentoModule } from '@coursera-web/cds-labs';

import CampaignHeroModuleRenderer, {
  useShouldShowCampaignHeroModule,
} from 'bundles/campaigns/module-renderers/CampaignHeroModuleRenderer';
import type { HeroBentoModuleFragment } from 'bundles/front-page/__generated__/contentfulTypes';
import SeoPageHeader from 'bundles/front-page/components/modules/hero-banner/SeoPageHeader';
import { useFrontPageRedesignQ32025Data } from 'bundles/front-page/providers/FrontPageRedesignQ32025Provider';
import getPredefinedPromos from 'bundles/front-page/redesign-modules/hero-banner/data/getPredefinedPromos';

type Props = {
  content?: HeroBentoModuleFragment;
};

const HeroBannerModuleRenderer = ({ content }: Props) => {
  const shouldShowCampaignHeroModule = useShouldShowCampaignHeroModule();
  const { enableFrontPageRedesignHeroCTAOptimization } = useFrontPageRedesignQ32025Data();

  let heroModuleOutput;

  if (shouldShowCampaignHeroModule) {
    heroModuleOutput = (
      <CampaignHeroModuleRenderer showOptimizedHeroBentoModule={enableFrontPageRedesignHeroCTAOptimization} />
    );
  } else {
    let cards: HeroBentoCardType[];
    if (content) {
      cards = (content.cardsCollection?.items?.filter(Boolean) ?? [])?.map((item, index) => {
        return {
          id: item.sys.id,
          index,
          ...item,
          eyebrow: {
            image: item.eyebrowImage,
            eyebrowImageHeight: item.eyebrowImageHeight,
          },
          cta: {
            target: item.ctaTarget,
            label: item.ctaText,
          },
          desktopImage: {
            ...item.image,
          },
          mobileImage: {
            ...(item.mobileImage ?? item.image),
          },
        };
      }) as Array<HeroBentoCardType>;
    } else {
      const defaultCards = getPredefinedPromos();
      cards = [defaultCards.joinForFree, defaultCards.c4b, defaultCards.promoCert];
    }
    heroModuleOutput = <HeroBentoModule cards={cards} showOptimization={enableFrontPageRedesignHeroCTAOptimization} />;
  }
  return (
    <div data-testid="front-page-hero-banner-module">
      <SeoPageHeader />
      {heroModuleOutput}
    </div>
  );
};

export default HeroBannerModuleRenderer;
